















import {Component, Vue, Prop} from 'vue-property-decorator'
import SurveyListItem from './SurveyListItem.vue'
import DateFormatter from '@/classes/DateFormatter'

@Component({
  components: {
    SurveyListItem,
  },
})
export default class SurveyListDate extends Vue {
  @Prop(String) public date!: string
  @Prop(Array) public tasks: any

  get day() {
    const dateFormatter = new DateFormatter()
    return dateFormatter.setFormat('DD').get(this.date)
  }

  get month() {
    const dateFormatter = new DateFormatter()
    return dateFormatter.setFormat('MMM').get(this.date)
  }

}
